import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../core/router/all_routes";
import api from "../../../core/api/config";
import GovHeader from "../../components/GovHeader";
import BotaoAjuda from "../../components/BotaoAjuda";

const Forgotpassword = () => {
  const route = all_routes;
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);

  const startTimer = () => setTimer(120);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email) {
      setError("O e-mail é obrigatório.");
      return;
    }

    if (timer > 0) {
      setError(`Aguarde ${timer} segundos antes de solicitar um novo envio.`);
      return;
    }

    setLoading(true);

    try {
      const response = await api.post("/api/password/email", { email });

      if (response.data?.message === "Link de redefinição enviado!") {
        setMessage(
          "E-mail enviado com sucesso! Verifique sua caixa de entrada e spam."
        );
        startTimer();
      } else {
        setMessage("E-mail enviado! Caso não receba, verifique o spam.");
      }
    } catch (err) {
      if (err.response) {
        const emailErrors = err.response.data.errors?.email || [];
        if (emailErrors.includes("Email is required")) {
          setError("O e-mail é obrigatório.");
        } else if (
          emailErrors.includes("Email must be a valid email address")
        ) {
          setError("Por favor, insira um e-mail válido.");
        } else if (emailErrors.includes("User not found")) {
          setError("E-mail não encontrado. Verifique e tente novamente.");
        } else {
          setError("Erro ao enviar e-mail. Tente novamente.");
        }
      } else {
        setError("Erro de conexão. Verifique sua internet.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <GovHeader />
        <div className="login-wrapper login-new">
          <div className="container">
            <div className="login-content user-login">
              <div className="login-logo">
                <img src="/assets/img/logo.png" alt="Logotipo ConeCta-SP" />
                <Link to={route.dashboard} className="login-logo logo-white">
                  <img
                    src="/assets/img/logo-white.png"
                    alt="Logotipo branco ConeCta-SP"
                  />
                </Link>
              </div>

              <form onSubmit={handleSubmit} action="signin-3">
                <div className="login-userset">
                  <div className="login-userheading">
                    <h3>Esqueceu a senha?</h3>
                    <h4>
                      Digite seu e-mail cadastrado e enviaremos um link para
                      redefinição de senha.
                    </h4>
                  </div>

                  <div className="form-login">
                    <label>Digite seu e-mail:</label>
                    <div className="form-addons">
                      <input
                        type="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <img
                        src="/assets/img/icons/mail.svg"
                        alt="ícone de e-mail"
                      />
                    </div>
                  </div>

                  {message && (
                    <p className="text-success d-flex align-items-center mt-2">
                      <i className="fas fa-check-circle me-2" />
                      {message}
                    </p>
                  )}
                  {error && (
                    <p className="text-danger d-flex align-items-center mt-2">
                      <i className="fas fa-exclamation-triangle me-2" />
                      {error}
                    </p>
                  )}

                  <div className="form-login">
                    <button
                      type="submit"
                      className="btn btn-login"
                      disabled={loading || timer > 0}
                    >
                      {loading
                        ? "Enviando..."
                        : timer > 0
                        ? `Aguarde ${timer}s para reenviar`
                        : "Enviar link de redefinição"}
                    </button>
                  </div>
                </div>
              </form>
              <div className="signinform text-center mt-3">
                <h4>
                  Retornar para a página de{" "}
                  <Link to={route.signin} className="hover-a">
                    login
                  </Link>
                </h4>
              </div>
              <div className="login-logo mt-3">
                <img
                  src="assets/img/logo-fosp.png"
                  alt="img"
                  width="Logotipo FOSP"
                />
              </div>
            </div>
          </div>
        </div>
        <BotaoAjuda />
      </div>
    </div>
  );
};

export default Forgotpassword;
